import { Controller } from "@hotwired/stimulus";
import { loadStripe } from "@stripe/stripe-js";

export default class extends Controller {
  connect() {
    this.stripe = null;

    loadStripe(this.element.dataset.key).then((stripe) => (this.stripe = stripe));
  }

  async loadFlow(event) {
    event.preventDefault();
    const response = await fetch("/stripe/financial_connections_sessions", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
      },
      credentials: "same-origin",
    });
    const { client_secret: clientSecret } = await response.json();

    const result = await this.stripe.collectFinancialConnectionsAccounts({
      clientSecret,
    });

    if (result.financialConnectionsSession.accounts.length > 0) {
      await fetch("/stripe/financial_connections_sessions/refresh_accounts", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content,
        },
        credentials: "same-origin",
      });

      const refreshFrameId = this.element.dataset.refreshFrameId;
      if (refreshFrameId) {
        document.getElementById(refreshFrameId).reload();
      }
    }
  }
}
